import { useState, useEffect, useCallback } from "react";
import axios from "axios";

import LottieLoaders from "../../../../components/UI/LottieLoaders";
import { config } from "../../../../config";

const Popup = ({
  trigger,
  setTrigger,
  title,
  url,
  children,
  handleCheckboxChange,
  isSelected,
}) => {
  const [images, setImages] = useState([]);

  const fetchImages = useCallback(async () => {
    try {
      const res = await axios.get(
        `${config.BASE_API_URL}/api/v1/screenshot?url=${url}`
      );
      setImages([
        {
          url: url,
          screenshotLink: res.data.screenshotUrl,
        },
      ]);
    } catch (err) {
      console.log(err);
    }
  }, [url]);

  useEffect(() => {
    if (trigger) {
      fetchImages();
    }
  }, [fetchImages, trigger]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        trigger &&
        !event.target.closest(".app-ai-quote-preview-popup-inner")
      ) {
        setTrigger(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [trigger, setTrigger]);

  const handleClose = () => {
    setTrigger(false);
  };

  return trigger ? (
    <div className="app-ai-quote-preview-popup">
      <div className="app-ai-quote-preview-popup-inner">
        <div className="app-ai-quote-preview-popup-header">
          <div className="app-ai-quote-preview-popup-header-inner">
            <div className="app-ai-quote-preview-popup-checkbox">
              <input
                type="checkbox"
                checked={isSelected}
                onChange={handleCheckboxChange}
              />
              <span />
            </div>
            <h4>{title}</h4>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1129_151)">
                  <path
                    d="M10 13.9999C10.3259 14.3325 10.7148 14.5967 11.1441 14.7771C11.5734 14.9575 12.0344 15.0504 12.5 15.0504C12.9656 15.0504 13.4266 14.9575 13.8559 14.7771C14.2852 14.5967 14.6741 14.3325 15 13.9999L19 9.99989C19.663 9.33685 20.0355 8.43757 20.0355 7.49989C20.0355 6.56221 19.663 5.66293 19 4.99989C18.337 4.33685 17.4377 3.96436 16.5 3.96436C15.5623 3.96436 14.663 4.33685 14 4.99989L13.5 5.49989"
                    stroke="#506BF0"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.0004 9.99997C13.6745 9.66737 13.2855 9.40315 12.8563 9.22276C12.427 9.04238 11.966 8.94946 11.5004 8.94946C11.0347 8.94946 10.5738 9.04238 10.1445 9.22276C9.71523 9.40315 9.32626 9.66737 9.00038 9.99997L5.00038 14C4.33734 14.663 3.96484 15.5623 3.96484 16.5C3.96484 17.4377 4.33734 18.3369 5.00038 19C5.66342 19.663 6.5627 20.0355 7.50038 20.0355C8.43806 20.0355 9.33734 19.663 10.0004 19L10.5004 18.5"
                    stroke="#506BF0"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1129_151">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
          <button
            onClick={handleClose}
            className="app-ai-quote-preview-popup-close-btn"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1061_9630)">
                <path
                  d="M18 6L6 18"
                  stroke="#506bf0"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 6L18 18"
                  stroke="#506bf0"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1061_9630)">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
        {children}
        <div className="app-ai-quote-preview-popup-image">
          {images.length > 0 ? (
            <img src={images[0].screenshotLink} alt="Screenshot" />
          ) : (
            <div className="app-ai-quote-preview-popup-loader">
              <LottieLoaders loader preview />
            </div>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default Popup;
